// src/features/tidsregistering/services/closingPeriods.js
import { apiClient } from '../../../services/api/client';

const BASE = '/api/v1/tidsregistering/closing-periods';

export const closingPeriodsAPI = {
  initiatePeriodClose: (data) =>
    apiClient.post(`${BASE}/initiate`, data),

  calculatePeriod: (closingPeriodId) =>
    apiClient.post(`${BASE}/${closingPeriodId}/calculate`),

  exportPeriod: (closingPeriodId) =>
    apiClient.post(`${BASE}/${closingPeriodId}/export`),

  getClosingPeriod: (closingPeriodId) =>
    apiClient.get(`${BASE}/${closingPeriodId}`),

  listForDepartment: () =>
    apiClient.get(`${BASE}/department`),

  listStaffClosingPeriods: (closingPeriodId) =>
    apiClient.get(`${BASE}/${closingPeriodId}/staff-closing-periods`),
};
